"use strict";
const _ = require("underscore");
const Moment = require("moment");
const MomentRange = require("moment-range");
const { forEach } = require("angular");
const moment = MomentRange.extendMoment(Moment);
const constants = require('../../common/Constants');

module.exports = [
    "$scope",
    "residents.service",
    "leads.service",
    "organisation.facility.service",
    "notification.service",
    "$stateParams",
    "$state",
    "dialog.service",
    "$q",
    "$location",
    "$anchorScroll",
    "$timeout",
    "$filter",
    "EffectiveDateTypes",
    "$rootScope",
    "featureFlags.service",
    "utilities.service",
    "referenceData.service",
    "HardshipFeeTypes",
    function (
        $scope,
        residentsService,
        leadsService,
        organisationFacilityService,
        notification,
        $stateParams,
        $state,
        dialogService,
        $q,
        $location,
        $anchorScroll,
        $timeout,
        $filter,
        EffectiveDateTypes,
        $rootScope,
        featureFlagsService,
        utilitiesService,
        referenceDataService,
        HardshipFeeTypes
    ) {
        var vm = this;
        // Attach form to vm after the form is initialized
        $scope.$watch("saveFinanceForm", function (form) {
            if (form) {
                vm.saveFinanceForm = form; // Attach the form to vm
            }
        });
        vm.enableAgedCareAct2025 = featureFlagsService.featureFlags.currentFacilityFeatureFlags.enableAgedCareAct2025;
        var residentId = $scope.residentId;
        vm.disableSendingExtraServiceToMedicare = featureFlagsService.featureFlags.systemConfigurationFlags.disableSendingExtraServiceToMedicare;
        this.isPrivateResidency = $stateParams.isPrivateResidency;
        var stateViewResidentFinancialsFees = "viewResident.financialsFees";
        var stateViewLeadFinancialsFees = "viewLead.financialsFees";
        vm.EffectiveDateTypes = EffectiveDateTypes;
        vm.billInvoiceMethod = null;
        vm.billPayers = [];
        vm.selectedBillPayer = null;
        vm.facilityOptionalServices = [];
        vm.retentionDatediff = [];
        vm.facilityServicesDropDownOptions = [];
        vm.triggerUniqueValidation = false;
        vm.dropdownSettings = {
            singleSelection: true,
            addAllOption: false,
            enableCheckAll: false,
            showClearSelectedItems: false,
        };
        vm.optionalServices = [];
        vm.setBasicDailyFeeToZero = false;
        vm.existingBillPayer = vm.selectedBillPayer;
        vm.isCheckboxTouched = false;
        vm.countries = [];
        vm.contact = {};
        vm.ccEmailDelimiter = ";";
        vm.ccIndex = 0;
        vm.emailAddresses = [{ name: "email", value: "" }];
        vm.invalidCCEmailLengthDisplayed = false;
        vm.ccEmails = "";
        vm.IsGreaterThanNOV = false;
        vm.Isretentionpaidmonth = false;
        vm.Isretentionpaidmonthplural = false;
        vm.Isretentionpaiddays = false;
        vm.ccEmailLengthLimit = 150;
        vm.hardshipFeeTypes = [];
        vm.showDailyMaxandFee = false;
        vm.totalRetentionFee = 0;
        vm.monthlyRetentionFee = 0;
        vm.leave = {};
        vm.eventHistory = {
            leaves: [],
            eventHistory: [],
            latestResidency: {},
            currentLoggedFacilityId: null
        }
        vm.showDropDown = function (optionalService) {
            return true;
        };
        vm.serviceOptionalServiceIdChanged = function (optionalService, ctrl) {
            if (ctrl.$modelValue) {
                var selectedItemId = ctrl.$modelValue[0].id;
                optionalService.optionalServiceId = selectedItemId;
                var facilityOptionalService = vm.facilityOptionalServices.find((x) => x.id == selectedItemId);
                optionalService.facilityOptionalServiceStartDateUtc = facilityOptionalService.startDateUtc;
                optionalService.facilityOptionalServiceEndDateUtc = facilityOptionalService.endDateUtc;
                ctrl.$setValidity("required", true);
            } else {
                ctrl.$setValidity("required", false);
            }
        };

        vm.hardshipFeeTypeChanged = function (hardship, ctrl) {
            if (typeof ctrl.$modelValue === 'number' && Number.isInteger(ctrl.$modelValue)) {
                hardship.fee = ctrl.$modelValue;
            } else if (typeof ctrl.$modelValue === 'object') {
                var selectedItemId = ctrl.$modelValue[0].id;
                hardship.fee = selectedItemId;
                ctrl.$setValidity("required", false);
            } else {
                ctrl.$setValidity("required", false);
            }
        };

        vm.onBillPayerSelected = function (item) {
            if (!item.exists) {
                dialogService.openDialog("app/residents/partials/addContactDialog.html", "addContactDialog.controller", {
                    resident: vm.resident,
                    payerType: vm.selectedBillPayer.payerType,
                    payerTypeName: vm.selectedBillPayer.payerTypeName,
                    state: $state.current.name,
                    callBack: vm.setContact,
                    persist: true,
                });
            }
            vm.populateCcEmailAddresses();
            vm.contact = vm.selectedBillPayer.contact;
            resetIsInvoiceEmailIfNoEmail();
            resetIsInvoicePostIfNoPostalAddress();
            setInvoiceMethodSelectedFlag();
            vm.finance.drawdownDAC = false;
            vm.finance.drawdownBDF = false;
            vm.finance.drawdownMTCF = false;
            vm.finance.drawdownAC = false;
            vm.finance.drawdownPI = false;
            vm.finance.drawdownITF = false;
            vm.finance.drawdownHC = false;
            vm.finance.drawdownNCCC = false;
        };

        vm.addEditFeeEffectiveDatesDialog = function (effectiveDateType) {
            dialogService.openDialog("app/residents/partials/addEditFeeEffectiveDatesDialog.html", "addEditFeeEffectiveDatesDialog.controller", {
                effectiveDateType: effectiveDateType,
                effectiveDates: _.filter(vm.finance.effectiveDates, function (item) {
                    return item.effectiveDateType === effectiveDateType;
                }),
                callBack: vm.setEffectiveDates,
                isAdmitted: vm.resident.isAdmitted,
                admissionDate: vm.resident.admissionDateUtc,
                isEmptyCollectionValid: false,
                isFirstValueBasedOnAdmissionDate: true,
                lifeTimeCap: vm.finance.lifetimeCap,
                lifeTimeCapEndDate: vm.finance.lifetimeCapEndDate,
                showAgreedMpirFields: (effectiveDateType === 'AgreedRoomPrice'),
                agreedMpirPersistence: vm.finance.agreedMpirPersistence,
                removeFirstRowAgreedMPIR: true,
                careFundingHocSupplementRates: vm.finance.careFundingHocSupplementRates
            });
        };

        vm.addEditAddress = function () {
            vm.setContactEmailAddress(vm.selectedBillPayer.payerType, vm.contact);
            dialogService.openDialog("app/residents/partials/addEditContactAddressDialog.html", "addEditContactDetailDialog.controller", {
                resident: vm.resident,
                payerType: vm.selectedBillPayer.payerType,
                payerTypeName: vm.selectedBillPayer.payerTypeName,
                contactField: "address",
                state: $state.current.name,
                callBack: vm.setContactEmailAddress,
                persist: true,
            });
        };

        vm.setContact = function (payerType, contact) {
            if (payerType === "PrimaryContact") {
                vm.resident.primaryContact = contact;
            } else {
                vm.resident.secondaryContact = contact;
            }

            var billPayer = _.find(vm.billPayers, { payerType: payerType });
            billPayer.name = contact.firstName + " " + contact.lastName;
            billPayer.contact = contact;
            billPayer.exists = true;
        };

        vm.setEffectiveDates = function (effectiveDateType, effectiveDates, mpirData) {
            // remove all effective dates of the specified type
            var newEffectiveDates = _.filter(vm.finance.effectiveDates, function (item) {
                return item.effectiveDateType !== effectiveDateType;
            });
            // now add new set specified by user
            _.each(effectiveDates, function (item) {
                newEffectiveDates.push(item);
            });

            // make sure effective dates exist for values that are relevant for the corresponding support level,
            // effective from the point where the support level becomes relevant
            if (effectiveDateType === "SupportLevel") {
                _.each(effectiveDates, function (effectiveDate) {
                    if (effectiveDate.value === "Supported") {
                        let matchingEffectiveDateDAC = _.filter(newEffectiveDates, function (findEffectiveDate) {
                            return findEffectiveDate.effectiveDateType == "DailyAccommodationContribution" && moment(findEffectiveDate.effectiveFromDate).isSame(effectiveDate.effectiveFromDate);
                        });
                        if (matchingEffectiveDateDAC.length === 0) {
                            newEffectiveDates.push({
                                effectiveDateType: "DailyAccommodationContribution",
                                effectiveFromDate: effectiveDate.effectiveFromDate,
                                value: "0",
                            });
                        }

                        let matchingEffectiveDateHOC = _.filter(newEffectiveDates, function (findEffectiveDate) {
                            return findEffectiveDate.effectiveDateType === "HotellingContributionFee" && moment(findEffectiveDate.effectiveFromDate).isSame(effectiveDate.effectiveFromDate);
                        });
                        if (matchingEffectiveDateHOC.length === 0) {
                            newEffectiveDates.push({
                                effectiveDateType: "HotellingContributionFee",
                                effectiveFromDate: effectiveDate.effectiveFromDate,
                                value: "0",
                            });
                        }

                        let matchingEffectiveDateNCCC = _.filter(newEffectiveDates, function (findEffectiveDate) {
                            return findEffectiveDate.effectiveDateType === "NonClinicalCareContributionFee" && moment(findEffectiveDate.effectiveFromDate).isSame(effectiveDate.effectiveFromDate);
                        });
                        if (matchingEffectiveDateNCCC.length === 0) {
                            newEffectiveDates.push({
                                effectiveDateType: "NonClinicalCareContributionFee",
                                effectiveFromDate: effectiveDate.effectiveFromDate,
                                value: "0",
                            });
                        }
                    } else if (effectiveDate.value === "Unsupported") {
                        let matchingEffectiveDate = _.filter(newEffectiveDates, function (findEffectiveDate) {
                            return findEffectiveDate.effectiveDateType === "AgreedRoomPrice" && moment(findEffectiveDate.effectiveFromDate).isSame(effectiveDate.effectiveFromDate);
                        });
                        if (matchingEffectiveDate.length === 0) {
                            newEffectiveDates.push({
                                effectiveDateType: "AgreedRoomPrice",
                                effectiveFromDate: effectiveDate.effectiveFromDate,
                                value: "0",
                            });
                        }

                        matchingEffectiveDate = _.filter(newEffectiveDates, function (findEffectiveDate) {
                            return findEffectiveDate.effectiveDateType === "HotellingContributionFee" && moment(findEffectiveDate.effectiveFromDate).isSame(effectiveDate.effectiveFromDate);
                        });
                        if (matchingEffectiveDate.length === 0) {
                            newEffectiveDates.push({
                                effectiveDateType: "HotellingContributionFee",
                                effectiveFromDate: effectiveDate.effectiveFromDate,
                                value: "0",
                            });
                        }

                        matchingEffectiveDate = _.filter(newEffectiveDates, function (findEffectiveDate) {
                            return findEffectiveDate.effectiveDateType === "NonClinicalCareContributionFee" && moment(findEffectiveDate.effectiveFromDate).isSame(effectiveDate.effectiveFromDate);
                        });
                        if (matchingEffectiveDate.length === 0) {
                            newEffectiveDates.push({
                                effectiveDateType: "NonClinicalCareContributionFee",
                                effectiveFromDate: effectiveDate.effectiveFromDate,
                                value: "0",
                            });
                        }
                    }
                });
            }

            if (mpirData) {
                vm.finance.agreedMpirPersistence = mpirData;
            }

            vm.finance.effectiveDates = newEffectiveDates;
            if (effectiveDateType === "RadPaid") vm.setRADPaid();
            if (effectiveDateType === "RacPaid") vm.setRACPaid();
            vm.initializeMPIRRate();
            if (vm.enableAgedCareAct2025 && !$rootScope.isBillingIntegratedFacility) vm.calculateTotalRetentions();

            if (effectiveDateType === EffectiveDateTypes.AgreedRoomPrice) {
                vm.getLatestDAPEffectiveDate();
            }
        };

        vm.getLatestDAPEffectiveDate = function () {
            var latestDAPdateList = _.chain(vm.finance.effectiveDates)
                .filter(function (effectiveDateItem) {
                    return effectiveDateItem.effectiveDateType === EffectiveDateTypes.AgreedRoomPrice;
                })
                .sortBy(function (item) {
                    return new Date(item.effectiveFromDate).getTime();;
                })
                .value();

            if (vm.finance.dapTransactionDateUtc && !isInvalidTransactionDate(vm.finance.dapTransactionDateUtc)) {
                var transactionDate = new Date(vm.finance.dapTransactionDateUtc);

                var applicableList = _.filter(latestDAPdateList, function (item) {
                    return new Date(item.effectiveFromDate).getTime() >= transactionDate.getTime();
                });

                if (applicableList.length > 0) {
                    vm.finance.latestDAP = _.last(applicableList);
                } else {
                    var transactionDateObj = new Date(vm.finance.dapTransactionDateUtc);
                    vm.finance.latestDAP = {
                        effectiveDateType: EffectiveDateTypes.AgreedRoomPrice,
                        effectiveFromDate: transactionDateObj.toISOString()
                    };
                }
            }
            else {
                vm.finance.latestDAP = _.last(latestDAPdateList);
            }
        }
        function isInvalidTransactionDate(dateStr) {
            return !dateStr || dateStr === "0001-01-01T00:00:00+00:00";
        }

        vm.loadEventHistory = function () {
            residentsService.getEventHistory(vm.resident.id).then((response) => {
                this.eventHistory = response;
                if (vm.enableAgedCareAct2025 && !$rootScope.isBillingIntegratedFacility) vm.calculateTotalRetentions();
            }, (error) => {
                this.notificationService.error("Unexpected error while retrieving resident event history");
            })
        }
        vm.setMonthlyRetentionFromBackend = function () {
            // Using the backend value for monthly retention
            if ($rootScope.isBillingIntegratedFacility && vm.enableAgedCareAct2025 && vm.finance.accommodationClass == "Post01Nov2025") {
                vm.monthlyRetentionFee = vm.finance.monthlyRetentionFee || 0;
                vm.totalRetentionFee = vm.finance.totalRetentionFee || 0;
            }
        };
        vm.calculateTotalRetentions = function () {
            if ($rootScope.isBillingIntegratedFacility || vm.finance.latestSupportLevel.value == "Unknown") {
                vm.totalRetentionFee = 0;
                return;
            }
            vm.totalRetentionFee = 0;
            vm.totalRetentionsEndDate = null;
            const effectiveDateType = vm.finance.latestSupportLevel.value == "Unsupported" ? "RadPaid" : "RacPaid";
            var radEffectiveDatesList = _.sortBy(_.filter(vm.finance.effectiveDates, (e) => e.effectiveDateType === effectiveDateType), (e) => new Date(e.effectiveFromDate));

            var monthMap = {};

            radEffectiveDatesList.forEach(function (item) {
                var date = new Date(item.effectiveFromDate);
                var year = date.getFullYear();
                var month = ('0' + (date.getMonth() + 1)).slice(-2);
                var monthKey = year + '-' + month;

                var numericValue = parseFloat(item.value) || 0;

                if (!monthMap[monthKey]) {
                    monthMap[monthKey] = Object.assign({}, item);
                    monthMap[monthKey].value = numericValue;
                } else {
                    monthMap[monthKey].value += numericValue;
                }
            });

            var radEffectiveDates = _.sortBy(Object.values(monthMap).sort(function (a, b) {
                return String(a.effectiveFromDate).localeCompare(String(b.effectiveFromDate));
            }), (e) => new Date(e.effectiveFromDate));
            var departedEffectiveDates = [...vm.eventHistory.eventsHistory.filter(x => x.eventType === "ResidentDeparted")]
                .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate));
            var totaldap = 0.0;
            if (radEffectiveDates.length > 0) {
                var totalMonths = 60;
                var effectiveFromDate = new Date(radEffectiveDates[0].effectiveFromDate);
                var totalPreviouslyPaidRetentionMonths = 0;
                if (departedEffectiveDates.length > 0) {
                    const eventDate = new Date(departedEffectiveDates[0].eventDate);
                    const departedEffectiveDate = new Date(eventDate.setDate(eventDate.getDate() + 1));
                    const years = departedEffectiveDate.getFullYear() - effectiveFromDate.getFullYear();
                    const months = departedEffectiveDate.getMonth() - effectiveFromDate.getMonth();
                    var departMonths = years * 12 + months;
                    if (departMonths < 60) {
                        totalMonths = departMonths;
                    }
                }
                else if (vm.finance.previouslyPaidRetention && vm.finance.retentionsStartDateUtc != undefined && vm.finance.retentionsEndDateUtc != undefined) {
                    var start = new Date(vm.finance.retentionsStartDateUtc);
                    var end = new Date(vm.finance.retentionsEndDateUtc);
                    end.setDate(end.getDate() + 1);
                    var years = end.getFullYear() - start.getFullYear();
                    var months = end.getMonth() - start.getMonth();
                    totalPreviouslyPaidRetentionMonths = (years * 12) + months;
                    totalMonths = totalMonths - totalPreviouslyPaidRetentionMonths;
                }
                const retentionRate = 0.02;
                let radBalance = 0;
                let totalRetentions = 0;

                for (let month = 0; month < totalMonths; month++) {
                    var currentDate = effectiveFromDate;
                    let year = currentDate.getFullYear();
                    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
                    var yearDays = isLeapYear ? 366 : 365;
                    const currentMonth = currentDate.getMonth();
                    const effectiveStartDate = radEffectiveDates.find(e => {
                        const date = new Date(e.effectiveFromDate);
                        return date.getMonth() === currentMonth && date.getFullYear() === year;
                    });

                    if (effectiveStartDate) {
                        radBalance += parseFloat(effectiveStartDate.value);
                    }
                    let daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
                    let monthlyRetention = (retentionRate * radBalance / yearDays) * daysInMonth;

                    totalRetentions += parseFloat(monthlyRetention);
                    radBalance -= monthlyRetention;
                    effectiveFromDate.setMonth(effectiveFromDate.getMonth() + 1);
                }
                vm.totalRetentionFee = totalRetentions;
                if (totalRetentions != 0) {
                    var effectiveDate = new Date(radEffectiveDates[0].effectiveFromDate);
                    effectiveDate.setMonth((effectiveDate.getMonth() + 60) - totalPreviouslyPaidRetentionMonths);
                    vm.totalRetentionsEndDate = effectiveDate;
                }
            }
        };
        vm.setRADPaid = function () {
            if ($rootScope.isBillingIntegratedFacility) return;
            //Todo: _filter and _foreach can be replaced with _.Chain
            var radEffectiveDates = _.filter(vm.finance.effectiveDates, (e) => e.effectiveDateType == "RadPaid");
            var totaldap = 0.0;
            if (radEffectiveDates.length > 0) {
                _.each(radEffectiveDates, function (item) {
                    totaldap = totaldap + parseFloat(item.value);
                });
                vm.finance.refundableAccommodationDepositPaid = totaldap;
            }
        };

        vm.setRACPaid = function () {
            if ($rootScope.isBillingIntegratedFacility) return;
            //Todo: _filter and _foreach can be replaced with _.Chain
            var racEffectiveDates = _.filter(vm.finance.effectiveDates, (e) => e.effectiveDateType == "RacPaid");
            var totaldac = 0.0;
            if (racEffectiveDates.length > 0) {
                _.each(racEffectiveDates, function (item) {
                    totaldac = totaldac + parseFloat(item.value);
                });
                vm.finance.refundableAccommodationContributionPaid = totaldac;
            }
        };

        vm.setContactEmailAddress = function (payerType, contact) {
            switch (payerType) {
                case "Resident": {
                    vm.resident.email = contact.email;
                    vm.resident.street1 = contact.street1;
                    vm.resident.street2 = contact.street2;
                    vm.resident.suburb = contact.suburb;
                    vm.resident.stateDescription = contact.stateDescription;
                    vm.resident.state = contact.state;
                    vm.resident.postCode = contact.postCode;
                    vm.resident.countryId = contact.countryId;
                    break;
                }
                case "PrimaryContact": {
                    vm.resident.primaryContact = contact;
                    break;
                }
                case "SecondaryContact": {
                    vm.resident.secondaryContact = contact;
                    break;
                }
            }

            var billPayer = _.find(vm.billPayers, { payerType: payerType });
            billPayer.contact = contact;
            billPayer.exists = true;
            vm.prepareContactDataBeforeUpdate();
        };

        function convertIntDatetoDateformat() {
            var str = constants.Constants.AGED_CARE_ACT2025_EFFECTIVE_DATE.toString();
            var year = parseInt(str.slice(0, 4), 10);
            var month = parseInt(str.slice(4, 6), 10) - 1; // Month is 0-based
            var day = parseInt(str.slice(6, 8), 10) - 1;
            vm.dateAgeCareAct2025EffectiveDate = new Date(Date.UTC(year, month, day, 23, 59, 0));
        };

        $scope.isBeforeNovemberFirst = function (dateStr) {
            var givenDate = new Date(dateStr); // Convert input to Date   
            return givenDate < vm.dateAgeCareAct2025EffectiveDate;
        };

        function initializeFinanceInformation() {
            convertIntDatetoDateformat();
            if ($scope.isBeforeNovemberFirst(vm.resident.admissionDateUtc)) {
                vm.IsGreaterThanNOV = true;
            } else {
                vm.IsGreaterThanNOV = false;
            }
            vm.isResidentCareTypeRespite = vm.finance.residentCareType === "Respite";
            vm.isResidentCareTypePermanent = vm.finance.residentCareType === "Permanent";
            vm.existingBillPayer = vm.selectedBillPayer;
            if (!vm.finance.pre2014CareLevel) {
                vm.finance.pre2014CareLevel = "Bond";
            }

            vm.isUnknown = function () {
                return vm.finance.latestSupportLevel.value === "Unknown";
            };
            vm.isSupported = function () {
                return vm.finance.latestSupportLevel.value === "Supported";
            };
            vm.isUnsupported = function () {
                return vm.finance.latestSupportLevel.value === "Unsupported";
            };

            vm.displayExtraService = function () {
                return !vm.disableSendingExtraServiceToMedicare && vm.finance && (vm.isResidentCareTypePermanent || vm.isResidentCareTypeRespite) && !vm.isPrivateResidency;
            };

            if (vm.isUnsupported && (vm.finance.contributionClass === 'Pre1Jul2014' || vm.finance.contributionClass === 'Jul2014toOct2025') && vm.finance.latestHotellingContributionFee !== undefined)
                vm.finance.latestHotellingContributionFee.effectiveFromDate = vm.finance.latestSupportLevel.effectiveFromDate;
            vm.setMonthlyRetentionFromBackend();
            vm.loadEventHistory();
            vm.setRACPaid();
            vm.setRADPaid();

            initializeEffectiveValuesPopoverOptions();
            if (vm.finance.previouslyPaidRetention) {
                vm.onRetentionDateChange();
            }
            if (vm.finance.previousNcccStartDate) {
                vm.finance.previousNcccStartDate = new Date(vm.finance.previousNcccStartDate);
            }
            if (vm.finance.previousNcccEndDate) {
                vm.finance.previousNcccEndDate = new Date(vm.finance.previousNcccEndDate);
            }
        }

        vm.addOptionalService = function addOptionalService(form) {
            var serviceWithValidationErrors = _.find(vm.optionalServices, function (service) {
                if (!service.optionalServiceId || !service.startDateUtc) {
                    return true;
                }
            });

            if (serviceWithValidationErrors) {
                for (var i = 0; i < vm.optionalServices.length; i++) {
                    if (form.hasOwnProperty("serviceOptionalServiceId" + i)) form["serviceOptionalServiceId" + i].$setTouched();
                    if (form.hasOwnProperty("serviceStartDate" + i)) form["serviceStartDate" + i].$setTouched();
                    if (form.hasOwnProperty("serviceEndDate" + i)) form["serviceEndDate" + i].$setTouched();
                }
                return;
            }

            if (validateOptionalServiceOverlap(form)) {
                return;
            }

            vm.optionalServices.push({
                index: vm.optionalServices.length,
                optionalServiceId: null,
                startDateUtc: null,
                endDateUtc: null,
                stopped: false,
                new: true,
                drawdown: false
            });

            initializeReadonlyEffectiveDatePopoverConfig(vm.optionalServices.length - 1);
        };

        vm.validateOptionalService = function (form, service, index) {
            var valid = true;
            var startDateCtrl = form["serviceStartDate" + index];
            var endDateCtrl = form["serviceEndDate" + index];

            if (moment.utc(service.startDateUtc).isBefore(moment.utc(service.facilityOptionalServiceStartDateUtc))) {
                startDateCtrl.$setValidity("startDateBeforeServiceStartDate", false);
                valid = false;
            } else {
                startDateCtrl.$setValidity("startDateBeforeServiceStartDate", true);
            }

            if (service.facilityOptionalServiceEndDateUtc && moment.utc(service.startDateUtc).isAfter(moment.utc(service.facilityOptionalServiceEndDateUtc))) {
                startDateCtrl.$setValidity("startDateAfterServiceEndDate", false);
                valid = false;
            } else {
                startDateCtrl.$setValidity("startDateAfterServiceEndDate", true);
            }

            if (service.endDateUtc && moment.utc(service.endDateUtc).isBefore(service.startDateUtc)) {
                endDateCtrl.$setValidity("invalidDate", false);
                valid = false;
            } else {
                endDateCtrl.$setValidity("invalidDate", true);
            }

            if (service.endDateUtc && service.facilityOptionalServiceEndDateUtc && moment.utc(service.endDateUtc).isAfter(moment.utc(service.facilityOptionalServiceEndDateUtc))) {
                endDateCtrl.$setValidity("endDateAfterServiceEndDate", false);
                valid = false;
            } else {
                endDateCtrl.$setValidity("endDateAfterServiceEndDate", true);
            }

            if (validateOptionalServiceOverlap(form)) {
                valid = false;
            }

            return valid;
        };

        function lookupOptionalServiceFormRowIndex(form, optionalServiceIndex) {
            return Object.keys(form)
                .filter((key) => {
                    return key.indexOf("index.") == 0 && form[key].$modelValue == optionalServiceIndex;
                })[0]
                .match(/\d+/)[0];
        }

        function validateOptionalServiceOverlap(form) {
            var hasError = false;

            for (var i = 0; i < vm.optionalServices.length; i++) {
                if (form.hasOwnProperty("serviceEndDate" + i)) form["serviceEndDate" + i].$setValidity("overlapDate", true);
            }

            // find the maximum date used, it will be used as the range delimiter for open date ranges (ie no end date)
            var maxDate = new Date();
            vm.optionalServices.forEach((optionalService) => {
                if (optionalService.startDateUtc > maxDate) maxDate = new Date(optionalService.startDateUtc.getTime());
                if (optionalService.endDateUtc > maxDate) maxDate = new Date(optionalService.endDateUtc.getTime());
            });

            // add a month onto the max date to give some time for the overlap to apply
            maxDate.setUTCMonth(maxDate.getUTCMonth() + 1);

            for (var i = 0; i < vm.optionalServices.length; i++) {
                if (!vm.optionalServices[i].startDateUtc) {
                    continue;
                }

                // if no end date, use the max date
                var range1 = moment.range(vm.optionalServices[i].startDateUtc, vm.optionalServices[i].endDateUtc ? vm.optionalServices[i].endDateUtc : maxDate);

                for (var j = i + 1; j < vm.optionalServices.length; j++) {
                    // only check overlaps for matching ids as different optional services can overlap
                    if (vm.optionalServices[i].optionalServiceId != vm.optionalServices[j].optionalServiceId) continue;

                    if (!vm.optionalServices[j].startDateUtc) {
                        continue;
                    }

                    // don't check if both are stopped
                    if (vm.optionalServices[i].stopped && vm.optionalServices[j].stopped) continue;

                    // if no end date, use the max date
                    var range2 = moment.range(vm.optionalServices[j].startDateUtc, vm.optionalServices[j].endDateUtc ? vm.optionalServices[j].endDateUtc : maxDate);

                    if (range1.overlaps(range2, { adjacent: true })) {
                        var formIndexI = lookupOptionalServiceFormRowIndex(form, i);
                        var formIndexJ = lookupOptionalServiceFormRowIndex(form, j);

                        if (form.hasOwnProperty("serviceEndDate" + formIndexI)) form["serviceEndDate" + formIndexI].$setValidity("overlapDate", false);

                        if (form.hasOwnProperty("serviceEndDate" + formIndexJ)) form["serviceEndDate" + formIndexJ].$setValidity("overlapDate", false);
                        hasError = true;
                    }
                }
            }

            return hasError;
        }

        vm.validateHardship = function (form, hardship, index) {
            var endDateCtrl = form["hardshipEndDate" + index];
            var startDateCtrl = form["hardshipStartDate" + index];
            var hardshipTypeFeeCtrl = form["hardshipTypeFee" + index];

            if (moment.utc(hardship.endDateUtc).isBefore(hardship.startDateUtc)) {
                endDateCtrl.$setValidity("invalidDate", false);
                return false;
            }

            if (moment.utc(hardship.startDateUtc).isBefore(vm.resident.admissionDateUtc)) {
                startDateCtrl.$setValidity("invalidBeforeAdmissionDate", false);
                return false;
            }

            validateHardshipsOverlap(form);

            endDateCtrl.$setValidity("invalidDate", true);
            startDateCtrl.$setValidity("invalidBeforeAdmissionDate", true);
            return false;
        };

        function validateHardshipsOverlap(form) {
            var hasError = false;

            for (var i = 0; i < vm.hardships.length; i++) {
                form["hardshipEndDate" + i].$setValidity("overlapDate", true);
            }

            for (var i = 0; i < vm.hardships.length; i++) {
                if (!vm.hardships[i].startDateUtc || !vm.hardships[i].endDateUtc) {
                    continue;
                }
                var range1 = moment.range(vm.hardships[i].startDateUtc, vm.hardships[i].endDateUtc);

                for (var j = i + 1; j < vm.hardships.length; j++) {
                    if (!vm.hardships[j].startDateUtc || !vm.hardships[j].endDateUtc) {
                        continue;
                    }

                    var range2 = moment.range(vm.hardships[j].startDateUtc, vm.hardships[j].endDateUtc);

                    if (range1.overlaps(range2, { adjacent: true })) {
                        form["hardshipEndDate" + i].$setValidity("overlapDate", false);
                        form["hardshipEndDate" + j].$setValidity("overlapDate", false);
                        hasError = true;
                    }
                }
            }

            return hasError;
        }

        vm.addHardship = function (form) {
            var hardshipWithValidationErrors = _.find(vm.hardships, function (hardship) {
                //skip for legacy datas
                if (hardship.isLegacy === 1 || hardship.governmentDailyContribution) {
                    return false;
                }
                return !hardship.endDateUtc || !hardship.startDateUtc || !hardship.dailyMax || !hardship.fee;
            });

            if (hardshipWithValidationErrors) {
                var index = vm.hardships.length - 1;
                if (form && form["hardshipStartDate" + index]) {
                    form["hardshipStartDate" + index].$setTouched();
                }
                if (form && form["hardshipEndDate" + index]) {
                    form["hardshipEndDate" + index].$setTouched();
                }
                if (form && form["hardshipDailyContribution" + index]) {
                    form["hardshipDailyContribution" + index].$setTouched();
                } else if (form && form["hardshipDailySupp" + index]) {
                    form["hardshipDailySupp" + index].$setTouched();
                }
                if (form["hardshipTypeFee" + index]) {
                    form["hardshipTypeFee" + index].$setTouched();
                }
                return;
            }

            if (validateHardshipsOverlap(form)) {
                return;
            }

            vm.isAddHardshipClicked = true;
            vm.hardships.push({
                hardshipTypeFee: null,
                startDateUtc: null,
                endDateUtc: null,
                dailyMax: null,
                dailySupp: null,
                isLegacy: 0 //set to 0 for new supplement records
            });
        };

        vm.removeHardship = function (form, index) {
            if (vm.hardships.length === 0) {
                return;
            }

            dialogService.openActionDialog(
                "Delete hardship supplement",
                "This will reverse any payments made for this entry.\n Are you sure you want to delete this supplement?",
                "hardship-delete",
                "Delete",
                () => {
                    vm.hardships.splice(index, 1);
                    if (form) {
                        validateHardshipsOverlap(form);
                    }
                },
                "btn-danger btn-inline-block-xsm",
                {
                    buttonLayout: "compact"
                }
            );
        };

        vm.onEffectiveDateCellCreated = function (rowIndex, formattedValue) {
            if (rowIndex > 0 || vm.resident.isAdmitted) {
                return formattedValue;
            }

            return "Admission date";
        };

        vm.onDapAmountCellCreated = function (rowIndex, formattedValue) {
            if (rowIndex === 0) {
                return $filter("currency")(vm.finance.dailyAccommodationPayment, "$", 2);
            }
            return formattedValue;
        };

        function initializeEffectiveValuesPopoverOptions(id, target) {
            const amountColumn = {
                headerText: "AMOUNT",
                headerCssClass: "amount-col",
                dataFieldName: "value",
                cellCssClass: "amount-col",
                filterName: "currency",
                currencySymbol: "$",
                currencyDecimalPlace: 2,
            };

            const mpirAmountColumn = {
                headerText: "AMOUNT",
                headerCssClass: "amount-col",
                dataFieldName: "value",
                cellCssClass: "amount-col",
                filterName: "percentage",
                currencyDecimalPlace: 2,
            };

            const dapAmountColumn = {
                headerText: "AMOUNT",
                headerCssClass: "amount-col",
                dataFieldName: "value",
                cellCssClass: "amount-col",
                filterName: "currency",
                currencySymbol: "$",
                currencyDecimalPlace: 2,
                onCellCreated: vm.onDapAmountCellCreated,
            };

            const effectiveDateColumn = {
                headerText: "EFFECTIVE DATE",
                headerCssClass: "effective-date-col",
                dataFieldName: "effectiveFromDate",
                cellCssClass: "effective-date-col",
                filterName: "dateInUtcTimezone",
                format: "dd MMM yyyy",
                onCellCreated: vm.onEffectiveDateCellCreated,
            };

            const supportLevelColumn = {
                headerText: "SUPPORT LEVEL",
                headerCssClass: "support-col",
                dataFieldName: "value",
                cellCssClass: "support-col",
            };

            const optionsTemplate = {
                placement: "bottom",
                autoClose: true,
                popoverCssClass: "fee-effective-popover",
                columns: [amountColumn, effectiveDateColumn],
                getRowCssClass: vm.getRowCssClass,
            };

            const mpirDateDisplayColumn = {
                headerText: "EFFECTIVE DATE",
                headerCssClass: "effective-date-col",
                dataFieldName: "dateDisplay",
                cellCssClass: "effective-date-col",
                onCellCreated: vm.onEffectiveDateCellCreated,
            };

            const IndexNumberColumn = {
                headerText: "VALUE",
                headerCssClass: "amount-col",
                dataFieldName: "value",
                cellCssClass: "amount-col",
                filterName: "number",
                currencyDecimalPlace: 4,
            };

            vm.meansTestedCareFeeOptions = _.extend({}, optionsTemplate, {
                id: "meanstestecarefee-link",
                target: "span#meanstestecarefee-effective-date",
            });

            vm.hotellingContributionFeeOptions = _.extend({}, optionsTemplate, {
                id: "hotellingfee-link",
                target: "span#hotellingfee-effective-date",
            });

            vm.nonClinicalCareContributionFeeOptions = _.extend({}, optionsTemplate, {
                id: "nonClinicalCarefee-link",
                target: "span#nonClinicalCarefee-effective-date",
            });

            vm.pre2014IncomeTestFeeOptions = _.extend({}, optionsTemplate, {
                id: "incometestedfee-link",
                target: "span#incometestedfee-effective-date",
            });

            vm.dailyAccommodationContributionOptions = _.extend({}, optionsTemplate, {
                id: "dac-link",
                target: "span#dac-effective-date",
            });

            vm.agreedRoomPriceOptions = _.extend({}, optionsTemplate, {
                id: "agreedroomprice-link",
                target: "span#agreedroomprice-effective-date",
            });

            vm.mpirOptions = _.extend({}, optionsTemplate, {
                id: "mpir-link",
                target: "span#mpir-effective-date",
                columns: [mpirAmountColumn, mpirDateDisplayColumn],
            });

            vm.dapOptions = _.extend({}, optionsTemplate, {
                id: "dap-link",
                target: "span#dap-effective-date",
                columns: [dapAmountColumn, _.extend({}, effectiveDateColumn, { headerText: "EFFECTIVE DATE" })],
            });

            vm.topupDACOptions = _.extend({}, optionsTemplate, {
                id: "topupdac-link",
                target: "span#topupdac-effective-date",
                columns: [amountColumn, _.extend({}, effectiveDateColumn, { headerText: "PAYMENT DATE" })],
            });

            vm.radPaidOptions = _.extend({}, optionsTemplate, {
                id: "radpaid-link",
                target: "span#rad-effective-date",
                columns: [amountColumn, _.extend({}, effectiveDateColumn, { headerText: "PAYMENT DATE" })],
            });

            vm.racPaidOptions = _.extend({}, optionsTemplate, {
                id: "racpaid-link",
                target: "span#rac-effective-date",
                columns: [amountColumn, _.extend({}, effectiveDateColumn, { headerText: "PAYMENT DATE" })],
            });

            vm.supportLevelOptions = _.extend({}, optionsTemplate, {
                id: "supportlevel-link",
                target: "span#supportlevel-effective-date",
                columns: [supportLevelColumn, effectiveDateColumn],
            });
            vm.indexOptions = _.extend({}, optionsTemplate, {
                id: "index-link",
                target: "span#index-effective-date",
                columns: [IndexNumberColumn, _.extend({}, effectiveDateColumn, { headerText: "EFFECTIVE DATE" })],
            });

            vm.basicDailyCareFeeOptions = _.extend({}, optionsTemplate, {
                id: "basicDailyCareFee-link",
                target: "span#basicDailyCareFee-effective-date",
                columns: [amountColumn, _.extend({}, effectiveDateColumn, { headerText: "EFFECTIVE DATE" })],
            });

            vm.privateDailyCareFeeOptions = _.extend({}, optionsTemplate, {
                id: "privateDailyCareFee-link",
                target: "span#privateDailyCareFee-effective-date",
            });



            sortEffectiveInformation("MeansTestCareFee", "meansTestedCareFees");
            sortEffectiveInformation("HotellingContributionFee", "hotellingContributionFees");
            sortEffectiveInformation("NonClinicalCareContributionFee", "nonClinicalCareContributionFees");
            sortEffectiveInformation("Pre2014IncomeTestFee", "pre2014IncomeTestFees");
            sortEffectiveInformation("DailyAccommodationContribution", "dailyAccommodationContributions");
            sortEffectiveInformation("SupportLevel", "supportLevels");
            sortEffectiveInformation("AgreedRoomPrice", "agreedRoomPrices");
            sortMpirEffectiveInformation("MPIRHistories", "MPIRHistory", "AgreedMPIR");
            sortEffectiveInformation("DailyAccommodationPayment", "dailyAccommodationPayments");
            sortEffectiveInformation("TopupDailyAccommodationContribution", "topupDailyAccommodationContributions");
            sortEffectiveInformation("RadPaid", "radPayments");
            sortEffectiveInformation("RacPaid", "racPayments");
            sortEffectiveInformation("BasicDailyCareFee", "basicDailyCareFees");
            sortEffectiveInformation("IndexNumber", "indexNumbers");
            sortEffectiveInformation("PrivateDailyCareFee", "privateDailyCareFees");
            sortEffectiveInformation("EffectiveFromDate", "effectiveFromDate");
        }

        function sortEffectiveInformation(type, items) {
            var currentUtcNow = moment().utc();
            vm[items] = _.sortBy(_.where(vm.finance.effectiveDates, { effectiveDateType: type }), function (item) {
                return -moment(item.effectiveFromDate);
            });
        }

        function sortMpirEffectiveInformation(targetKey, historyType, agreedType) {
            var typesToFilter = [historyType, agreedType];
            var filteredItems = _.filter(vm.finance.effectiveDates, function (item) {
                return _.contains(typesToFilter, item.effectiveDateType);
            });
            var mappedItems = _.map(filteredItems, function (item) {
                var displayItem = angular.copy(item);

                let formattedDate = moment(displayItem.effectiveFromDate).format('DD MMM YYYY');

                displayItem.dateDisplay = formattedDate;
                displayItem.mpirValueDisplay = displayItem.value; // Start with the base value

                if (displayItem.effectiveDateType === agreedType) {
                    displayItem.mpirValueDisplay = displayItem.mpirValueDisplay + ' (AM)';
                    displayItem.dateDisplay = formattedDate + ' (AM)';
                }

                return displayItem;
            });

            vm[targetKey] = _.sortBy(mappedItems, function (item) {
                return -moment(item.effectiveFromDate);
            });
        }

        vm.getRowCssClass = function (data) {
            return _.isEqual(data, vm.finance.latestMeansTestedCareFee) ||
                _.isEqual(data, vm.finance.latestPrivateDailyCareFee) ||
                _.isEqual(data, vm.finance.latestPre2014IncomeTestFee) ||
                _.isEqual(data, vm.finance.latestDailyAccommodationContribution) ||
                _.isEqual(data, vm.finance.latestSupportLevel) ||
                _.isEqual(data, vm.finance.latestDAP) ||
                _.isEqual(data, vm.finance.latestTopupDAC) ||
                _.isEqual(data, vm.finance.latestAgreedRoomPrice) ||
                _.isEqual(data, vm.finance.latestHotellingContributionFee) ||
                _.isEqual(data, vm.finance.latestNonClinicalCareContributionFee)
                ? "latest"
                : "";
        };

        function getBillPayer(contact) {
            var result = {
                name: "Add",
                contact: null,
                exists: false,
            };

            if (!contact) {
                return result;
            }

            if (!contact.firstName && !contact.lastName) {
                result.name = "Add";
                result.exists = false;
            } else {
                result.name = contact.firstName + " " + contact.lastName;
                result.exists = true;
            }

            result.contact = contact;
            return result;
        }

        function getResidentContact() {
            var contact = {};
            contact.email = vm.resident.email;

            contact.street1 = vm.resident.street1;
            contact.street2 = vm.resident.street2;
            contact.suburb = vm.resident.suburb;
            contact.stateDescription = vm.resident.stateDescription;
            contact.state = vm.resident.state;
            contact.postCode = vm.resident.postCode;
            contact.country = vm.resident.country;
            contact.countryId = vm.resident.countryId;

            return contact;
        }

        function initializeResidentInformation() {
            var primaryContact = getBillPayer(vm.resident.primaryContact);
            var secondaryContact = getBillPayer(vm.resident.secondaryContact);

            vm.billPayers = [
                {
                    payerType: "empty",
                    name: null,
                    exists: true,
                },
                {
                    payerType: "Resident",
                    payerTypeName: "Resident",
                    name: vm.resident.firstName + " " + vm.resident.lastName,
                    billPayerDetail: vm.resident.billPayerDetail,
                    contact: getResidentContact(),
                    exists: true,
                },
                {
                    payerType: "PrimaryContact",
                    payerTypeName: "Primary contact",
                    name: primaryContact.name,
                    billPayerDetail: primaryContact.contact ? primaryContact.contact.billPayerDetail : null,
                    contact: primaryContact.contact,
                    exists: primaryContact.exists,
                },
                {
                    payerType: "SecondaryContact",
                    payerTypeName: "Secondary contact",
                    name: secondaryContact.name,
                    billPayerDetail: secondaryContact.contact ? secondaryContact.contact.billPayerDetail : null,
                    contact: secondaryContact.contact,
                    exists: secondaryContact.exists,
                },
            ];

            if (vm.finance.billPayerType) {
                vm.selectedBillPayer = _.find(vm.billPayers, { payerType: vm.finance.billPayerType });
                vm.existingBillPayer = vm.selectedBillPayer;
                setInvoiceMethodSelectedFlag();
                vm.populateCcEmailAddresses();
            }
        }

        function resetIsInvoiceEmailIfNoEmail() {
            if (vm.selectedBillPayer && vm.selectedBillPayer.billPayerDetail) {
                if (vm.selectedBillPayer.billPayerDetail.isInvoiceEmail && vm.selectedBillPayer.contact && vm.selectedBillPayer.contact.email === "") {
                    vm.selectedBillPayer.billPayerDetail.isInvoiceEmail = false;
                    vm.finance.isInvoiceEmail = false;
                }
            }
        }

        function resetIsInvoicePostIfNoPostalAddress() {
            if (vm.selectedBillPayer && vm.selectedBillPayer.billPayerDetail) {
                if (vm.selectedBillPayer.billPayerDetail.isInvoicePost && vm.selectedBillPayer.contact && !vm.hasContactPost()) {
                    vm.selectedBillPayer.billPayerDetail.isInvoicePost = false;
                    vm.finance.isInvoicePost = false;
                }
            }
        }

        function setInvoiceMethodSelectedFlag() {
            if (vm.selectedBillPayer && vm.selectedBillPayer.billPayerDetail) {
                if (!vm.selectedBillPayer.billPayerDetail.isInvoiceEmail && !vm.selectedBillPayer.billPayerDetail.isInvoicePost) {
                    vm.billInvoiceMethod = null;
                } else {
                    vm.billInvoiceMethod = true;
                }
            } else {
                vm.billInvoiceMethod = null;
            }
        }

        function initializeOptionalServiceInformation() {
            if (vm.facilityOptionalServices == null || vm.facilityOptionalServices.length == 0 || vm.optionalServices == null) return;

            var currentTime = new Date();

            // start with initialising the facility-level optional services

            // create a lookup array so we can easily refernce the service by its id
            vm.facilityOptionalServicesLookupById = [];

            vm.facilityOptionalServices.forEach((facilityOptionalService) => {
                // populate service dropdown options
                if (!facilityOptionalService.stopped) {
                    vm.facilityServicesDropDownOptions.push({
                        id: facilityOptionalService.id,
                        text: facilityOptionalService.typeDescription + ` - ${facilityOptionalService.billingPeriod.toLowerCase()} until ${facilityOptionalService.stopBillingEvent.toLowerCase()}`,
                    });
                }

                // populate the lookup
                vm.facilityOptionalServicesLookupById[parseInt(facilityOptionalService.id)] = facilityOptionalService;

                // convert the dates to Date objects
                facilityOptionalService.ratesList.forEach((rate) => {
                    rate.startDate = new Date(rate.startDate.toString());
                    rate.endDate = rate.endDate ? new Date(rate.endDate.toString()) : null;
                });

                // determine today's rate
                var useRate = facilityOptionalService.ratesList[facilityOptionalService.ratesList.length - 1];
                facilityOptionalService.ratesList
                    .slice()
                    .reverse()
                    .forEach((rate) => {
                        if (currentTime >= rate.startDate.getTime()) {
                            useRate = rate;
                        }
                    });
                facilityOptionalService.rate = useRate.value;
                facilityOptionalService.todayRateIndex = facilityOptionalService.ratesList.indexOf(useRate);
            });

            // now do the resident-level optional services
            var index = 0;
            vm.optionalServices.forEach((optionalService) => {
                optionalService.index = index;
                index++;
                if (optionalService.drawdown === undefined || optionalService.drawdown === null) {
                    optionalService.drawdown = false;
                }
                // convert the dates to Date objects
                optionalService.startDateUtc = new Date(optionalService.startDateUtc.toString());
                optionalService.endDateUtc = optionalService.endDateUtc ? new Date(optionalService.endDateUtc.replace("23:59:59", "00:00:00")) : null;

                let endDateUtcEndOfDay = null;
                if (optionalService.endDateUtc != null) {
                    optionalService.endDateUtc = new Date(
                        Date.UTC(
                            optionalService.endDateUtc.getUTCFullYear(),
                            optionalService.endDateUtc.getUTCMonth(),
                            optionalService.endDateUtc.getUTCDate(),
                            optionalService.endDateUtc.getUTCHours(),
                            optionalService.endDateUtc.getUTCMinutes(),
                            optionalService.endDateUtc.getUTCSeconds()
                        )
                    );
                    endDateUtcEndOfDay = new Date(optionalService.endDateUtc);
                    endDateUtcEndOfDay.setHours(23);
                    endDateUtcEndOfDay.setMinutes(59);
                    endDateUtcEndOfDay.setSeconds(59);
                }

                // use the facility rate, unless we're outside our service date range, then use 0
                optionalService.rate = vm.facilityOptionalServicesLookupById[optionalService.optionalServiceId].rate;
                if (currentTime.getTime() < optionalService.startDateUtc.getTime() || (endDateUtcEndOfDay != null && currentTime.getTime() > endDateUtcEndOfDay)) {
                    optionalService.rate = "0";
                }

                optionalService.applicableRatesList = prepareRatesListForResidentServiceWindow(
                    vm.facilityOptionalServicesLookupById[optionalService.optionalServiceId].ratesList,
                    vm.resident.admissionDateUtc,
                    optionalService.startDateUtc,
                    optionalService.endDateUtc
                );
            });
        }

        function prepareRatesListForResidentServiceWindow(ratesList, admissionDate, serviceStartDate, serviceEndDate) {
            admissionDate = new Date(admissionDate);
            var output = ratesList.slice();
            var windowStart = admissionDate != null && admissionDate.getTime() > serviceStartDate.getTime() ? admissionDate : serviceStartDate;
            var windowEnd = serviceEndDate ? new Date(serviceEndDate) : null;

            // delete all entries that are completely outside our window
            for (let i = 0; i < output.length; i++) {
                var startDate = output[i].startDate;
                var endDate = output[i].endDate;
                var value = output[i].value;
                var deleteThisEntry = false;

                if (endDate != null && endDate.getTime() < windowStart.getTime()) {
                    deleteThisEntry = true;
                } else if (windowEnd != null && windowEnd.getTime() < startDate.getTime()) {
                    deleteThisEntry = true;
                }
                if (deleteThisEntry) {
                    output.splice(i--, 1);
                } else {
                    output[i] = {
                        startDate: startDate,
                        endDate: endDate,
                        value: value,
                    };
                }
            }

            // if we have no entries remaining (ie there are no rates within our window) then just return zero from the window start
            if (output.length == 0) {
                output.push({
                    startDate: windowStart,
                    value: "0",
                    endDate: null,
                });
                return output;
            }

            // set the start date of the earliest rate to match our window start if necessary
            var earliestRate = output[output.length - 1];
            if (earliestRate.startDate.getTime() < windowStart.getTime()) {
                earliestRate.startDate = windowStart;
            }
            // set the end date of the latest rate to match our window end if necessary
            var latestRate = output[0];
            if ((latestRate.endDate != null && windowEnd != null && latestRate.endDate.getTime() > windowEnd.getTime()) || latestRate.endDate == null) {
                latestRate.endDate = windowEnd;
            }
            // if the latest rate isn't a zero, but it has an end date, then add a new zero to signify the end of the service
            if (latestRate.value != "0" && latestRate.endDate != null) {
                var zeroEffectiveDate = new Date(latestRate.endDate.getTime());

                zeroEffectiveDate.setDate(zeroEffectiveDate.getDate() + 1);

                output.unshift({
                    startDate: zeroEffectiveDate,
                    value: "0",
                });
            }

            return output;
        }

        function initializeReadonlyEffectiveDatePopoverConfig(index = null) {
            if (vm.facilityOptionalServices == null || vm.facilityOptionalServices.length === 0 || vm.optionalServices == null) return;

            if (index === null) {
                vm.readonlyEffectiveDatePopoverConfigs = [];
                vm.optionalServices.forEach((service) => {
                    initializeReadonlyEffectiveDatePopoverConfig(service.index);
                });
            } else {
                vm.readonlyEffectiveDatePopoverConfigs[index] = {
                    id: "value-link-" + index,
                    placement: "bottom",
                    target: "a#value-link-" + index,
                    autoClose: true,
                    popoverCssClass: "table-popover fee-effective-popover-edit",
                    columns: [
                        {
                            headerText: "AMOUNT",
                            headerCssClass: "support-col",
                            dataFieldName: "value",
                            cellCssClass: "support-col",
                            filterName: "currency",
                        },
                        {
                            headerText: "EFFECTIVE DATE",
                            headerCssClass: "effective-date-col",
                            dataFieldName: "startDate",
                            cellCssClass: "effective-date-col",
                            filterName: "date",
                            format: "dd MMM yyyy",
                            onCellCreated: (rowIndex, formattedValue) => {
                                return formattedValue;
                            },
                        },
                    ],
                };
            }
        }
        function initializeViewModeEffectiveDatePopoverConfig(index = null) {
            if (vm.facilityOptionalServices == null || vm.facilityOptionalServices.length === 0 || vm.optionalServices == null) return;

            if (index === null) {
                vm.viewModeEffectiveDatePopoverConfigs = [];
                vm.optionalServices.forEach((service) => {
                    initializeViewModeEffectiveDatePopoverConfig(service.index);
                });
            } else {
                vm.viewModeEffectiveDatePopoverConfigs[index] = {
                    id: "value-link-view-" + index,
                    placement: "bottom",
                    target: "a#value-link-view-" + index,
                    autoClose: true,
                    popoverCssClass: "fee-effective-popover",
                    columns: [
                        {
                            headerText: "AMOUNT",
                            headerCssClass: "support-col",
                            dataFieldName: "value",
                            cellCssClass: "support-col",
                            filterName: "currency",
                        },
                        {
                            headerText: "EFFECTIVE DATE",
                            headerCssClass: "effective-date-col",
                            dataFieldName: "startDate",
                            cellCssClass: "effective-date-col",
                            filterName: "date",
                            format: "dd MMM yyyy",
                            onCellCreated: (rowIndex, formattedValue) => {
                                return formattedValue;
                            },
                        },
                    ],
                };
            }
        }
        //for multiple row pop up
        function initializeHardshipHistoryDataMultiple() {
            //creating container for hardship history data
            vm.hardshipHistoryData = {},
                //creating array for hardship options
                vm.hardshipOptions = [];
            //Processing each hardship
            _.forEach(vm.hardships, function (hardship, index) {
                if (!hardship || !hardship.fee) {
                    // console.warn('warning: Hardship at index',index,'has no fee property:', hardship);
                    return;
                }
                //get the fee type (dap,bond/charge,etc.)
                var feeType = hardship.fee;

                //creating key for hardship
                var key = 'hardship_' + index;
                var historyData = [];
                //adding current value
                historyData.push({
                    value: hardship.dailySupp,
                    effectiveFromDate: hardship.startDateUtc
                });
                // finding all historical entries for this fee type across all hardships
                var allHistoricalEntries = [];
                // firstly, checking all hardships for the same fee type
                _.forEach(vm.hardships, function (h) {
                    if (h.fee === feeType) {
                        allHistoricalEntries.push({
                            value: h.dailySupp,
                            effectiveFromDate: h.startDateUtc
                        });
                    }
                });

                //finding entries in effectiveDates
                if (vm.finance && vm.finance.effectiveDates) {
                    var effectiveDateEntries = _.filter(vm.finance.effectiveDates, function (date) {
                        return date.effectiveDateType === feeType;
                    });
                    _.forEach(effectiveDateEntries, function (entry) {
                        allHistoricalEntries.push({
                            value: entry.value,
                            effectiveFromDate: entry.effectiveFromDate
                        });
                    });
                }
                //Removing duplicates based on date and value
                historyData = _.uniq(allHistoricalEntries, false, function (item) {
                    return String(item.effectiveFromDate) + '_' + item.value;
                });
                //sorting by date (newest first)
                vm.hardshipHistoryData[key] = _.sortBy(historyData, function (item) {
                    return -(new Date(item.effectiveFromDate).getTime());
                });
                //creating option for hardship index
                vm.hardshipOptions[index] = {
                    id: 'hdailySupp' + index,
                    placement: 'bottom',
                    autoClose: true,
                    popoverCssClass: 'fee-effective-popover',
                    title: "History popover",
                    columns: [
                        {
                            headerText: "Effective date",
                            headerCssClass: "effective-date-col",
                            dataFieldName: "effectiveFromDate",
                            cellCssClass: "effective-date-col",
                            filterName: "dateInUtcTimezone",
                            format: "dd-MMM-yyyy",
                        },
                        {
                            headerText: "Daily supp.",
                            headerCssClass: "hardship-supp-col",
                            dataFieldName: "value",
                            cellCssClass: "hardship-supp-col",
                            filterName: "currency",
                            currencySymbol: "$",
                            currencyDecimalPlace: 2
                        }
                    ]
                };
            });
        }
        vm.removeOptionalService = function (optionalService) {
            vm.optionalServices.splice(vm.optionalServices.indexOf(optionalService), 1);
        };

        var promises = [
            residentsService.getEventHistory(residentId),
            residentsService.getResidentFinanceFees(residentId),
            $state.current.name === "editResident.financialsFees" || $state.current.name === "viewResident.financialsFees" ? residentsService.getResident(residentId) : leadsService.getLead(residentId),
            organisationFacilityService.getOptionalServices(),
        ];

        $q.all(promises)
            .then(res => $q.all([...res, residentsService.getUpdatedDap(res[1].financeFees,residentId)])).then(
                function (results) {
                    results.eventHistory = results[0];
                    results.finance = results[1];
                    results.resident = results[2];
                    results.facilityOptionalServices = results[3];

                    vm.eventHistory = results.eventHistory;
                    vm.finance = results.finance.financeFees;
                    vm.setBasicDailyFeeToZero = vm.finance.isBasicDailyFeeZeroForPrivateResident;
                    vm.facility = results.finance.facility;
                    vm.resident = results.resident;
                    vm.optionalServices = results.finance.financeFees.optionalServices;
                    vm.mPIRRates = vm.finance.mpirRates;
                    vm.hardships = results.finance.financeFees.hardships.map(function (hardship) {
                        //If this is a legacy record(has governmentDailyContribution but no fee)
                        if ((hardship.governmentDailyContribution !== null) &&
                            (!hardship.fee || hardship.fee === null || hardship.fee === 0)) {
                            //Setting isLegacy flag
                            hardship.isLegacy = 1;
                            //Copying governmentDailyContribution to dailySupp for display
                            hardship.dailySupp = hardship.governmentDailyContribution;
                            //setting a default fee to prevent errors
                            hardship.fee = 0;
                        } else {
                            hardship.isLegacy = 0;
                        }
                        return hardship;
                    });
                    vm.facilityOptionalServices = results.facilityOptionalServices;
                    vm.hardshipFeeTypes = Object.entries(HardshipFeeTypes).map(([key, value], index) => ({
                        id: value, // Generate sequential IDs starting from 1
                        text: key,
                    }));
                    // Respite Residents: Only BDF hardship is available.
                    // Permanent Residents: All hardship fee types (e.g. BDF,Bond/Charge,DAPHHOC,HNCCC,HHOC) are available.
                    if (vm.resident.careType === 'Respite') {
                        // Here BDF id is 2-only include it for Respite Residents.
                        vm.hardshipFeeTypes = vm.hardshipFeeTypes.filter(item => item.id === HardshipFeeTypes['Basic daily fee']);
                    }
                    initializeHardshipHistoryDataMultiple(); // for multiple row pop up
                    initializeFinanceInformation();
                    initializeResidentInformation();
                    initializeOptionalServiceInformation();
                    initializeReadonlyEffectiveDatePopoverConfig();
                    initializeViewModeEffectiveDatePopoverConfig();
                    referenceDataService.getCountries().then(
                        (data) => {
                            vm.countries = data;
                            const emptyItem = {
                                id: null,
                                displayName: "",
                            };

                            vm.countries.splice(0, 0, emptyItem);
                            vm.prepareContactDataBeforeUpdate();

                            vm.selectedCountry = _.findWhere(vm.countries, { id: vm.resident.countryId }).displayName;
                        },
                        () => {
                            notification.error("Unexpected error occurred while loading the countries.");
                        }
                    );
                    vm.hardships.forEach(hardship => {
                        hardship = vm.updateDailySupp(hardship);
                    });
                    $timeout(function () {
                        if ($stateParams["#"]) {
                            $location.hash($stateParams["#"]);
                            $anchorScroll();
                        }
                    }, 0);
                },
                function (error) {
                    if (error.status === 404) {
                        vm.finance = {
                            financeFees: {
                                effectiveDates: [],
                            },
                        };
                    } else {
                        notification.error("Unable to display financials. Either your computer is offline, or Resident Manager is having problems of its own.");
                    }
                }
            );
        vm.updateDailySupp = function (hardship) {
            //Skipping recalculation for legacy records
            if (hardship.isLegacy === 1 || hardship.governmentDailyContribution) {
                //for legacy records, ensuring governmentDailyContribution is updated
                hardship.governmentDailyContribution = hardship.dailySupp;
                return hardship;
            }
            //Applying calculation logic, for non-legacy records
            if (hardship.fee === HardshipFeeTypes['Basic daily fee']) {
                let basicDailyFee = vm.isPrivateResidency && vm.setBasicDailyFeeToZero ? 0 : vm.finance.basicDailyFee;
                hardship.dailySupp = (parseFloat(hardship.dailyMax) > parseFloat(basicDailyFee)) ? 0 : (basicDailyFee - hardship.dailyMax);
                hardship.isLegacy = 0;
            }
            else if (hardship.fee === HardshipFeeTypes['DAP']) {
                let dapValue = vm.finance.dailyAccommodationPayment || 0;
                hardship.dailySupp = (parseFloat(hardship.dailyMax) > parseFloat(dapValue)) ? 0 : (dapValue - hardship.dailyMax);
                hardship.isLegacy = 0;
            }
            else if (hardship.fee === HardshipFeeTypes['Bond/Charge']) {
                let dailyAmount = 0;
                if (vm.finance.pre2014CareLevel === "Bond") {
                    dailyAmount = vm.finance.pre2014BondDailyAmount || 0;
                }
                else if (vm.finance.pre2014CareLevel === "Charge") {
                    dailyAmount = vm.finance.pre2014DailyAmount || 0;
                }
                else if (vm.isUnsupported()) { //Already implemented before.
                    dailyAmount = vm.finance.dailyAccommodationPayment || 0;
                }
                hardship.dailySupp = (parseFloat(hardship.dailyMax) > parseFloat(dailyAmount)) ? 0 : (dailyAmount - hardship.dailyMax);
                //Always set as non-legacy for Bond/Charge  
                hardship.isLegacy = 0;
            }
            else if (hardship.fee === HardshipFeeTypes['Hotelling contribution']) {
                let dapValue = vm.finance.latestHotellingContributionFee.value || 0;
                hardship.dailySupp = (parseFloat(hardship.dailyMax) > parseFloat(dapValue)) ? 0 : (dapValue - hardship.dailyMax);
                hardship.isLegacy = 0;
            }
            else if (hardship.fee === HardshipFeeTypes['NCCC']) {
                let dapValue = vm.finance.latestNonClinicalCareContributionFee.value || 0;
                hardship.dailySupp = (parseFloat(hardship.dailyMax) > parseFloat(dapValue)) ? 0 : (dapValue - hardship.dailyMax);
                hardship.isLegacy = 0;
            }
            return hardship;
        }
        vm.contactEmail = function () {
            return vm.selectedBillPayer ? (vm.selectedBillPayer.contact ? vm.selectedBillPayer.contact.email : "No email") : "No email";
        };

        vm.hasContact = function () {
            if (vm.selectedBillPayer) {
                if (vm.selectedBillPayer.contact) {
                    return true;
                } else {
                    return false;
                }
            }

            return false;
        };

        vm.hasContactEmail = function () {
            if (vm.selectedBillPayer) {
                if (vm.selectedBillPayer.contact) {
                    return vm.selectedBillPayer.contact.email;
                } else {
                    return false;
                }
            }

            return false;
        };

        vm.hasContactPost = function () {
            if (vm.selectedBillPayer) {
                if (vm.selectedBillPayer.contact) {
                    return (
                        vm.selectedBillPayer.contact.street1 ||
                        vm.selectedBillPayer.contact.street2 ||
                        vm.selectedBillPayer.contact.suburb ||
                        vm.selectedBillPayer.contact.stateDescription ||
                        vm.selectedBillPayer.contact.postCode ||
                        vm.selectedBillPayer.contact.country
                    );
                } else {
                    return false;
                }
            }

            return false;
        };

        vm.invoiceEmailChecked = function (checked) {
            if (vm.selectedBillPayer && vm.selectedBillPayer.billPayerDetail) {
                vm.selectedBillPayer.billPayerDetail.isInvoiceEmail = checked;
                vm.isCheckboxTouched = true;
            } else {
                vm.selectedBillPayer.billPayerDetail = vm.getNewBillPayerDetail();
                vm.selectedBillPayer.billPayerDetail.isInvoiceEmail = checked;
                vm.isCheckboxTouched = false;
            }
            if (!checked && !vm.finance.isInvoicePost) {
                vm.billInvoiceMethod = null;
            } else {
                vm.finance.isInvoiceEmail = checked;
                vm.billInvoiceMethod = checked || vm.finance.isInvoicePost;
            }
        };

        vm.invoicePostChecked = function (checked) {
            if (vm.selectedBillPayer && vm.selectedBillPayer.billPayerDetail) {
                vm.selectedBillPayer.billPayerDetail.isInvoicePost = checked;
                vm.isCheckboxTouched = true;
            } else {
                vm.selectedBillPayer.billPayerDetail = vm.getNewBillPayerDetail();
                vm.selectedBillPayer.billPayerDetail.isInvoicePost = checked;
                vm.isCheckboxTouched = false;
            }
            if (!vm.finance.isInvoiceEmail && !checked) {
                vm.billInvoiceMethod = null;
            } else {
                vm.finance.isInvoicePost = checked;
                vm.billInvoiceMethod = checked || vm.finance.isInvoiceEmail;
            }
        };

        vm.billPaymentMethodName = function () {
            return vm.finance.billPaymentMethod === "DirectDebit" ? "Direct debit" : vm.finance.billPaymentMethod;
        };

        vm.isAnyDrawdownSelected = function () {
            if (vm.finance.drawdownDAC || vm.finance.drawdownBDF || vm.finance.drawdownMTCF || vm.finance.drawdownAC || vm.finance.drawdownPI || vm.finance.drawdownITF || vm.finance.drawdownHC || vm.finance.drawdownNCCC) {
                return true;
            }

            return false;
        };

        vm.redirectToViewDetail = function () {
            var goToState = $state.current.name === "viewResident.financialsFees" ? "viewResident" : "viewLead";
            $state.go(goToState, { residentId: $scope.residentId, "#": vm.selectedBillPayer.payerType.substring(0, 1).toLowerCase() + vm.selectedBillPayer.payerType.substring(1) });
        };

        vm.save = function (isvalid) {
            if (vm.selectedBillPayer?.billPayerDetail?.isInvoicePost && !vm.hasContactPost()) {
                isvalid = false;
            }
            if (!isvalid) {
                return;
            }
            vm.calculateNcccDuration();
            if (vm.ncccDurationValidationFailed) {
                return;
            }
            let ccEmails = "";
            if (vm.selectedBillPayer?.billPayerDetail?.isInvoiceEmail) {
                ccEmails = vm.ccEmails.replaceAll(",", vm.ccEmailDelimiter);

                if (vm.contact.billPayerDetail) {
                    vm.contact.billPayerDetail.ccEmail = ccEmails;
                } else {
                    vm.contact.billPayerDetail = vm.getNewBillPayerDetail();
                    vm.contact.billPayerDetail.ccEmail = ccEmails;
                }
                vm.saveContact(isvalid);
            }
            if (vm.selectedBillPayer) {
                if (vm.selectedBillPayer.payerType !== "empty") {
                    vm.finance.billPayerType = vm.selectedBillPayer.payerType;
                    vm.finance.billPaymentMethod = vm.selectedBillPayer.billPayerDetail.paymentMethod;
                    vm.finance.isInvoiceEmail = vm.selectedBillPayer.billPayerDetail.isInvoiceEmail;
                    vm.finance.isInvoicePost = vm.selectedBillPayer.billPayerDetail.isInvoicePost;
                    vm.finance.ccEmail = ccEmails;
                    if (vm.selectedBillPayer.billPayerDetail.paymentMethod === "DirectDebit") {
                        vm.finance.bankAccountName = vm.selectedBillPayer.billPayerDetail.accountName;
                        vm.finance.bankName = vm.selectedBillPayer.billPayerDetail.bankName;
                        vm.finance.bsb = vm.selectedBillPayer.billPayerDetail.bsb;
                        vm.finance.accountNumber = vm.selectedBillPayer.billPayerDetail.accountNumber;
                    }
                } else {
                    vm.finance.billPayerType = null;
                }
            }
            vm.finance.effectiveDates = _.filter(vm.finance.effectiveDates, function (effectiveDateItem) {
                return effectiveDateItem.effectiveDateType !== EffectiveDateTypes.BasicDailyCareFee;
            });

            //code Agreed MPIR
            var mpirData = vm.finance.agreedMpirPersistence;
            var AgreedMPIRType = "AgreedMPIR";
            var MPIRHistoryType = "MPIRHistory";

            if (mpirData && mpirData.useAgreedMPIR) {
                if (!mpirData.selectedHistoricalDate || mpirData.agreedMPIR === null) {
                    return;
                }

                var targetDateString = mpirData.selectedHistoricalDate;
                var newMPIRValue = mpirData.agreedMPIR;

                var targetDateMoment = moment(targetDateString);

                if (targetDateMoment.isValid() && mpirData.useAgreedMPIR) {

                    var itemToUpdate = _.find(vm.finance.effectiveDates, function (item) {

                        var isMpirType = item.effectiveDateType === MPIRHistoryType || item.effectiveDateType === AgreedMPIRType;

                        return isMpirType &&
                            moment(item.effectiveFromDate).isSame(targetDateMoment, 'day');
                    });

                    if (itemToUpdate) {
                        itemToUpdate.value = newMPIRValue.toString();
                        itemToUpdate.effectiveDateType = "AgreedMPIR";
                    }
                }
            }
            //end Agreed MPIR code

            vm.finance.isBasicDailyFeeZeroForPrivateResident = vm.setBasicDailyFeeToZero;
            vm.hardships.forEach(hardship => {
                hardship = vm.updateDailySupp(hardship);
            });
            vm.finance.hardships = vm.hardships;
            vm.hardships.forEach(function (hardship) {
                if (hardship.isLegacy === 1 || hardship.governmentDailyContribution) {
                    //for legacy records, need to ensure
                    hardship.isLegacy = 1;
                    //DailySupp should match governmentDailyContribution value
                    hardship.dailySupp = hardship.governmentDailyContribution;
                    //for legacy records, to ensure that these are actual numbers - not null
                    //setting to 0 to avoid c# nullable conversion issues
                    hardship.dailyMax = 0;
                    hardship.fee = 0;
                }
                else {
                    //for non legacy records,
                    hardship.isLegacy = 0;
                    hardship.dailyMax = parseFloat(hardship.dailyMax) || 0;
                    hardship.dailySupp = parseFloat(hardship.dailySupp) || 0;
                    hardship.fee = parseInt(hardship.fee) || 0;
                    hardship.governmentDailyContribution = 0; //setting to 0 for new records
                }
            });
            vm.finance = vm.finance || {};
            vm.finance.resident = vm.resident;
            residentsService.saveResidentFinanceFees(residentId, vm.finance).then(
                function () {
                    notification.success("Changes have been saved.");
                    vm.redirectToView();
                },
                function (err) {
                    if (err?.data?.modelState?.effectiveDates) {
                        notification.error(err.data.modelState.effectiveDates);
                    }
                    else {
                        notification.error("Unable to save changes. Either your computer is offline, or Resident Manager is having problems of its own.");
                    }
                }
            );
        };

        vm.redirectToView = function () {
            if ($state.current.name === "editResident.financialsFees") {
                $state.go(stateViewResidentFinancialsFees, { residentId: residentId, isPrivateResidency: this.isPrivateResidency });
            } else if ($state.current.name === "editLead.financialsFees") {
                $state.go(stateViewLeadFinancialsFees, { residentId: residentId, isPrivateResidency: this.isPrivateResidency });
            }
        };

        vm.isAccommodationCostRequiredForPre2014Care = function () {
            return vm.finance.pre2014Care && vm.finance.pre2014ContinueCare && vm.finance.pre2014CareLevel === "Bond";
        };

        vm.showFundingTab = function () {
            switch ($state.current.name) {
                case "viewResident.financialsFees":
                case "editResident.financialsFees":
                    $state.go("viewResident.financialsFunding", { residentId: residentId });
                    break;
                case "viewLead.financialsFees":
                case "editLead.financialsFees":
                    $state.go("viewLead.financialsFunding", { residentId: residentId });
                    break;
            }
        };

        vm.showTransactionTab = function () {
            switch ($state.current.name) {
                case "viewResident.financialsFees":
                case "editResident.financialsFees":
                    $state.go("viewResident.financialsTransaction", { residentId: residentId, isPrivateResidency: this.isPrivateResidency });
                    break;
                case "viewLead.financialsFees":
                case "editLead.financialsFees":
                    $state.go("viewLead.financialsTransaction", { residentId: residentId, isPrivateResidency: this.isPrivateResidency });
                    break;
            }
        };

        vm.navigateToEdit = function () {
            switch ($state.current.name) {
                case "viewResident.financialsFees":
                    $state.go("editResident.financialsFees", { residentId: residentId, isPrivateResidency: this.isPrivateResidency });
                    break;
                case "viewLead.financialsFees":
                    $state.go("editLead.financialsFees", { residentId: residentId, isPrivateResidency: this.isPrivateResidency });
                    break;
            }
        };

        vm.showMeansTestedCareFeesChangeHistory = function () {
            dialogService.openDialog("app/residents/partials/meansTestedCareFeesChangeHistoryDialog.html", "meansTestedCareFeesChangeHistoryDialog.controller", {
                residentName: `${vm.resident.firstName} ${vm.resident.lastName}`,
                meansTestedCareFees: vm.meansTestedCareFees,
            });
        };

        vm.addNewCcEmailAddress = function (ccEmailId = "") {
            vm.emailAddresses.push({ name: "ccEmail" + vm.ccIndex, value: ccEmailId });
            vm.ccIndex++;
        };

        vm.saveContact = (isValid) => {
            if (isValid) {
                const selectedCountry = vm.countries.filter((c) => c.id == vm.contact.countryId);

                if (selectedCountry.length > 0) {
                    vm.contact.country = selectedCountry[0].displayName;
                }

                let resident = vm.setResidentContactDataBeforeUpdate();
                let updateResident = $state.current.name === "editResident.financialsFees" ? residentsService.updateResident : leadsService.updateLead;
                updateResident({ resident: resident }).then(
                    () => {
                        vm.setContactEmailAddress(vm.selectedBillPayer.payerType, vm.contact);
                    },
                    () => {
                        notification.error("Unexpected error occurred while saving " + this.modalConfig.payerTypeName + " " + this.modalConfig.contactField + ".");
                    }
                );
            }
        };

        vm.populateCcEmailAddresses = () => {
            vm.resetCcEmails();
            let ccEmails = [];
            let ccEmail = "";
            switch (vm.selectedBillPayer.payerType) {
                case "Resident":
                    ccEmail = vm.resident.billPayerDetail?.ccEmail;
                    break;
                case "PrimaryContact":
                    ccEmail = vm.resident.primaryContact?.billPayerDetail?.ccEmail;
                    break;
                case "SecondaryContact":
                    ccEmail = vm.resident.secondaryContact?.billPayerDetail?.ccEmail;
                    break;
                default:
                    break;
            }
            if (ccEmail) {
                ccEmails = ccEmail?.split(vm.ccEmailDelimiter);
                ccEmails?.forEach((ccEmail) => {
                    vm.addNewCcEmailAddress(ccEmail);
                });
                vm.getCcEmailIds();
            }
        };

        vm.resetCcEmails = () => {
            vm.emailAddresses = [{ name: "email", value: "" }];
            vm.ccIndex = 0;
        };

        vm.getCcEmailIds = () => {
            vm.ccEmails = vm.emailAddresses
                .map(function (item) {
                    return item.value;
                })
                .filter(Boolean)
                .toString();

            if (vm.ccEmails.length > 0) {
                vm.ccEmails = vm.ccEmails.charAt(vm.ccEmails.length - 1) == "," ? vm.ccEmails.slice(0, -1) : vm.ccEmails;
                vm.ccEmails = vm.ccEmails.charAt(0) == "," ? vm.ccEmails.slice(1) : vm.ccEmails;
            }

            // If CC Email length exceed to 150 characters then show validation message.
            if (vm.ccEmails.length > vm.ccEmailLengthLimit) {
                vm.invalidCCEmailLengthDisplayed = true;
            } else {
                vm.invalidCCEmailLengthDisplayed = false;
            }
        };

        vm.setResidentContactDataBeforeUpdate = () => {
            vm.resident.billPayerType = vm.selectedBillPayer.payerType;

            switch (vm.selectedBillPayer.payerType) {
                case "Resident": {
                    vm.resident.email = vm.contact.email;
                    vm.resident.street1 = vm.contact.street1;
                    vm.resident.street2 = vm.contact.street2;
                    vm.resident.suburb = vm.contact.suburb;
                    vm.resident.state = vm.contact.state;
                    vm.resident.postCode = vm.contact.postCode;
                    vm.resident.countryId = vm.contact.countryId;
                    vm.resident.country = vm.contact.country;
                    if (vm.resident.billPayerDetail) {
                        vm.resident.billPayerDetail.ccEmail = vm.contact?.billPayerDetail?.ccEmail;
                    } else {
                        vm.resident.billPayerDetail = vm.getNewBillPayerDetail();
                        vm.resident.billPayerDetail.ccEmail = vm.contact?.billPayerDetail?.ccEmail;
                    }
                    break;
                }
                case "PrimaryContact": {
                    vm.resident.primaryContact.email = vm.contact.email;
                    vm.resident.primaryContact.isBillPayer = true;
                    if (vm.resident.secondaryContact) {
                        vm.resident.secondaryContact.isBillPayer = false;
                    }
                    if (vm.resident.primaryContact.billPayerDetail) {
                        vm.resident.primaryContact.billPayerDetail.ccEmail = vm.contact?.billPayerDetail?.ccEmail;
                    } else {
                        vm.resident.primaryContact.billPayerDetail = vm.getNewBillPayerDetail();
                        vm.resident.primaryContact.billPayerDetail.ccEmail = vm.contact?.billPayerDetail?.ccEmail;
                    }

                    break;
                }
                case "SecondaryContact": {
                    vm.resident.secondaryContact.email = vm.contact.email;
                    vm.resident.secondaryContact.isBillPayer = true;
                    if (vm.resident.primaryContact) {
                        vm.resident.primaryContact.isBillPayer = false;
                    }
                    if (vm.resident.secondaryContact.billPayerDetail) {
                        vm.resident.secondaryContact.billPayerDetail.ccEmail = vm.contact?.billPayerDetail?.ccEmail;
                    } else {
                        vm.resident.secondaryContact.billPayerDetail = vm.getNewBillPayerDetail();
                        vm.resident.secondaryContact.billPayerDetail.ccEmail = vm.contact?.billPayerDetail?.ccEmail;
                    }
                    break;
                }
            }

            vm.resident.stateDescription = utilitiesService.getStateDescription(vm.contact.state);

            return vm.resident;
        };

        vm.getNewBillPayerDetail = function () {
            return {
                ccEmail: null,
                isInvoiceEmail: vm.selectedBillPayer.billPayerDetail?.isInvoiceEmail ? vm.selectedBillPayer.billPayerDetail.isInvoiceEmail : null,
                isInvoicePost: vm.selectedBillPayer.billPayerDetail?.isInvoicePost ? vm.selectedBillPayer.billPayerDetail.isInvoicePost : null,
                paymentMethod: vm.selectedBillPayer.billPayerDetail?.paymentMethod ? vm.selectedBillPayer.billPayerDetail.paymentMethod : null
            };
        };

        vm.deleteRow = function (index) {
            if (vm.emailAddresses.length === 0) {
                return;
            }
            dialogService.openActionDialog(
                "Delete email address",
                "Are you sure you want to delete this email address?",
                "hardship-delete",
                "Delete",
                () => {
                    vm.emailAddresses.splice(index, 1);
                    vm.getCcEmailIds();
                },
                "btn-danger btn-inline-block-xsm"
            );
        };

        vm.prepareContactDataBeforeUpdate = function () {
            switch (vm.selectedBillPayer?.payerType) {
                case "Resident": {
                    vm.contact.email = vm.resident.email;
                    vm.contact.street1 = vm.resident.street1;
                    vm.contact.street2 = vm.resident.street2;
                    vm.contact.suburb = vm.resident.suburb;
                    vm.contact.stateDescription = utilitiesService.getStateDescription(vm.resident.state);
                    vm.contact.state = vm.resident.state;
                    vm.contact.postCode = vm.resident.postCode;
                    vm.contact.countryId = vm.resident.countryId;
                    break;
                }
                case "PrimaryContact": {
                    vm.contact = vm.resident.primaryContact;
                    break;
                }
                case "SecondaryContact": {
                    vm.contact = vm.resident.secondaryContact;
                    break;
                }
            }
        };

        vm.markFormValid = function (event) {
            if (event.isUnique) {
                vm.makeFormValid();
            }
        };

        vm.makeFormValid = function () {
            angular.forEach(vm.saveFinanceForm, function (field, key) {
                if (key[0] !== "$" && key.indexOf("ccEmail") > -1) {
                    field.$setValidity("customError", true); // Clear error
                    field.$setPristine();
                    field.$setUntouched();
                }
            });
            vm.triggerUniqueValidation = true;

            // Optionally, reset after validation is triggered
            $timeout(function () {
                vm.triggerUniqueValidation = false; // Reset trigger to false for future uses
            }, 0);
        };

        vm.getLabel = function (feeValue) {
            for (const key in HardshipFeeTypes) {
                if (HardshipFeeTypes[key] === feeValue) {
                    return key; // Return the label
                }
            }
            return '';
        };

        vm.initializeMPIRRate = function () {
            if (!vm.resident.isAdmitted) {
                return;
            }
            const mpirData = vm.finance.agreedMpirPersistence;
            const AgreedMPIRType = "AgreedMPIR";
            // const MPIRHistoryType = "MPIRHistory";

            const useAgreedMPIR = mpirData && mpirData.useAgreedMPIR && mpirData.agreedMPIR !== null && mpirData.agreedMPIR !== undefined;

            if (useAgreedMPIR) {
                const selectedHistoricalDate = moment.utc(mpirData.selectedHistoricalDate);
                const latestEffectiveDate = vm.finance.latestAgreedRoomPrice
                    ? moment.utc(vm.finance.latestAgreedRoomPrice.effectiveFromDate)
                    : null;

                if (vm.MPIRHistories && vm.MPIRHistories.length > 0) {
                    const MPIRHistorieseffectiveFromDate = moment.utc(vm.MPIRHistories[0].effectiveFromDate);

                    let isLatestDateNotInHistory = true;

                    if (latestEffectiveDate) {
                        const matchingHistoryEntry = _.find(vm.MPIRHistories, function (historyItem) {
                            const historyDate = moment.utc(historyItem.effectiveFromDate);
                            return latestEffectiveDate.isSame(historyDate, 'day');
                        });

                        isLatestDateNotInHistory = !matchingHistoryEntry;
                    }

                    if (selectedHistoricalDate.isSame(MPIRHistorieseffectiveFromDate, 'day') || isLatestDateNotInHistory) {
                        vm.finance.maximumPermissibleInterestRate = mpirData.agreedMPIR;
                    }


                    return;
                }

                else if (latestEffectiveDate) {
                    vm.finance.maximumPermissibleInterestRate = mpirData.agreedMPIR;
                    return;
                }
            }

            var matchingEffectiveDate = _.filter(vm.finance.effectiveDates, function (findEffectiveDate) {
                return findEffectiveDate.effectiveDateType === "AgreedRoomPrice";
            });

            var matchingAgreedMPIR = _.filter(vm.finance.effectiveDates, function (findEffectiveDate) {
                return findEffectiveDate.effectiveDateType === "AgreedMPIR";
            });

            if (matchingEffectiveDate.length > 0 && matchingAgreedMPIR.length > 0) {
                if (matchingAgreedMPIR[0] != undefined || matchingAgreedMPIR[0] != null) {
                    const matchingEffectiveDateDate = moment.utc(matchingEffectiveDate[0].effectiveFromDate);
                    const matchingAgreedMPIRDate = moment.utc(matchingAgreedMPIR[0].effectiveFromDate);

                    if (matchingEffectiveDateDate.isSame(matchingAgreedMPIRDate, 'day')) {
                        vm.finance.maximumPermissibleInterestRate = matchingAgreedMPIR[0].value;
                        return;
                    }
                }
            }

            var mPIRRate = _.filter(vm.finance.mpirRates, function (item) {
                const dateStartDate = new Date(item.startDateUtc);
                const dateEndDate = new Date(item.endDateUtc);
                const dateEffDateFrom = new Date(vm.finance.latestAgreedRoomPrice.effectiveFromDate);

                if (dateStartDate.getTime() == dateEffDateFrom.getTime()) {
                    return moment.utc(item.startDateUtc);
                }
                else if (dateEndDate.getTime() == dateEffDateFrom.getTime()) {
                    return moment.utc(item.endDateUtc);
                }
                else if ((dateStartDate.getTime() < dateEffDateFrom.getTime()) && (dateEndDate.getTime() > dateEffDateFrom.getTime())) {
                    return (moment.utc(item.startDateUtc).isBefore(moment.utc(vm.finance.latestAgreedRoomPrice.effectiveFromDate)) && moment.utc(item.endDateUtc).isAfter(moment.utc(vm.finance.latestAgreedRoomPrice.effectiveFromDate)));
                }
            });
            if (mPIRRate.length > 0 && (vm.finance.latestSupportLevel.value === "Unsupported" || vm.finance.latestSupportLevel.value === "Unknown")) {
                vm.finance.maximumPermissibleInterestRate = mPIRRate[0].rate;
            }

        };

        vm.onRetentionDateChange = function () {
            if (!vm.finance.retentionsStartDateUtc || !vm.finance.retentionsEndDateUtc) {
                return;
            }
            let retentionsStartDateUtc = new Date(vm.finance.retentionsStartDateUtc);
            let retentionsEndDateUtc = new Date(vm.finance.retentionsEndDateUtc);
            let backupretentionsEndDateUtc = new Date(vm.finance.retentionsEndDateUtc);
            vm.Isretentionpaidmonth = false;
            vm.Isretentionpaiddays = false;
            vm.Isretentionpaidmonthplural = false;
            // Ensure retentionsStartDateUtc is earlier
            if (retentionsStartDateUtc > retentionsEndDateUtc) {
                notification.error("RetentionsStartDateUtc must be earlier than to RetentionsEndDateUtc.");
                return;
            }

            let years = retentionsEndDateUtc.getFullYear() - retentionsStartDateUtc.getFullYear();
            let months = retentionsEndDateUtc.getMonth() - retentionsStartDateUtc.getMonth() + years * 12;
            let days;
            // Calculate day difference
            const retentionsStartDateUtcCopy = new Date(retentionsStartDateUtc.getFullYear(), retentionsStartDateUtc.getMonth() + months, retentionsStartDateUtc.getDate());
            if (retentionsStartDateUtcCopy > retentionsEndDateUtc) {
                months--;
                retentionsStartDateUtcCopy.setMonth(retentionsStartDateUtcCopy.getMonth() - 1);
            }

            days = Math.floor(((retentionsEndDateUtc.setDate(retentionsEndDateUtc.getDate() + 1)) - retentionsStartDateUtcCopy) / (1000 * 60 * 60 * 24));
            if ((months == 0)) {
                let retentionsEndMonth = backupretentionsEndDateUtc.getMonth();
                let retentionsEndyear = backupretentionsEndDateUtc.getFullYear();
                let retentionsEnddays = new Date(retentionsEndyear, retentionsEndMonth + 1, 0).getDate();
                if (retentionsEnddays == days) {
                    months = 1;
                    days = 0;
                    vm.retentionDatediff = [{ months, days }];
                } else {
                    vm.retentionDatediff = [{ months, days }];
                }
            } else {
                vm.retentionDatediff = [{ months, days }];
            }
            if (months > 0) {
                vm.Isretentionpaidmonth = true;
            }
            if (months > 1) {
                vm.Isretentionpaidmonthplural = true;
            }
            if (days > 0) {
                vm.Isretentionpaiddays = true;
            }
            if (vm.enableAgedCareAct2025 && !$rootScope.isBillingIntegratedFacility) vm.calculateTotalRetentions();
        };

        vm.resetValues = function (event) {
            if ((vm.finance.retentionsStartDateUtc == undefined && vm.finance.retentionsEndDateUtc == undefined) || !event) {
                vm.retentionDatediff = [{ months: 0, days: 0 }];
            }

            if (!event) {
                vm.finance.retentionsStartDateUtc = undefined;
                vm.finance.retentionsEndDateUtc = undefined;
            }
            if (vm.enableAgedCareAct2025 && !$rootScope.isBillingIntegratedFacility) vm.calculateTotalRetentions();
        };
        vm.calculateNcccDuration = function () {
            const startDate = vm.finance.previousNcccStartDate;
            const endDate = vm.finance.previousNcccEndDate;
            const admissionDate = vm.finance.admissionDateUtc || null;

            vm.finance.previousNcccDuration = '';
            vm.ncccDurationValidationFailed = false; // reset before checks

            if (startDate && endDate) {
                const start = moment(startDate);
                const end = moment(endDate);
                const today = moment().startOf('day');
                const admission = admissionDate ? moment(admissionDate) : null;

                if (end.isAfter(today)) {
                    notification.error("Previous End Date cannot be in the future.");
                    vm.ncccDurationValidationFailed = true;
                    return;
                }

                if (admission && end.isAfter(admission)) {
                    notification.error("Previous End Date cannot be after the Admission Date.");
                    vm.ncccDurationValidationFailed = true;
                    return;
                }

                if (start.isAfter(end)) {
                    notification.error("Previous Start Date cannot be after Previous End Date.");
                    vm.ncccDurationValidationFailed = true;
                    return;
                }

                const duration = moment.duration(end.clone().add(1, 'day').diff(start));
                const months = duration.months() + duration.years() * 12;
                const days = duration.days();

                vm.finance.previousNcccDuration = `${months} month${months !== 1 ? 's' : ''}, ${days} day${days !== 1 ? 's' : ''}`;
            }
        };

    },
];
